import styles from './ProductCellContent.scss';

import React, { useState } from 'react';

import { LinkVariant, ProductModule } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Button } from 'src/components/Button/Button';
import { ContentImage, ContentImageEntry } from 'src/components/ContentImage/ContentImage';
import { ProductModal } from 'src/components/ProductModal/ProductModal';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';

interface ProductCellContentProps {
  productDetails?: FlatEntry<ProductModule>;
}

export const ProductCellContent: React.FC<ProductCellContentProps> = ({ productDetails }) => {
  const [modalState, toggleModal] = useState(false);

  return (
    <>
      <Button
        variant={LinkVariant.TEXT}
        onClick={productDetails ? () => toggleModal(true) : undefined}
        className={styles.productCellButton}
        isFullWidth
      >
        <ContentImage
          entry={productDetails && (productDetails?.images as ContentImageEntry[])[0]}
          className={styles.productCellImage}
          data-test="product-cell-image"
        />
        <TextV2
          value={productDetails?.name}
          variant="body-small"
          className={styles.productCellText}
          data-test="product-cell-text"
        />
      </Button>
      <ProductModal closeModal={() => toggleModal(bool => !bool)} modalOpen={modalState} productDetails={productDetails} />
    </>
  );
};
